import React from 'react';
import Navbar from '../Components/Landingpage/Navbar';
import Footer from '../Components/Landingpage/Footer';
import BackToTop from '../Components/Landingpage/BackToTop';
import { getShortName, getStats } from '../data/companyDetails';

const AboutUs = () => {
  const shortName = getShortName();
  const stats = getStats();

  return (
    <>
      <Navbar />
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="row">
            <div className="col-12">
              <h1 className="display-4 mb-4 text-primary">About {shortName}</h1>
              <p className="lead mb-4">
                Welcome to {shortName} - The ultimate destination for live streaming and short video content.
              </p>
              
              <div className="row g-4 mt-5">
                <div className="col-md-6">
                  <h3 className="text-primary mb-3">Our Mission</h3>
                  <p>
                    Our mission is to provide the best live streaming experience for users worldwide. 
                    We believe in connecting people through engaging content and interactive features.
                  </p>
                </div>
                <div className="col-md-6">
                  <h3 className="text-primary mb-3">Our Vision</h3>
                  <p>
                    To become the leading platform for short-form video content and live streaming, 
                    fostering creativity and community engagement across the globe.
                  </p>
                </div>
              </div>

              <div className="row g-4 mt-5">
                <div className="col-md-4">
                  <div className="text-center p-4 bg-light rounded">
                    <i className="fas fa-users fa-3x text-primary mb-3"></i>
                    <h4>{stats.users}</h4>
                    <p>Happy Users</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="text-center p-4 bg-light rounded">
                    <i className="fas fa-video fa-3x text-primary mb-3"></i>
                    <h4>{stats.videos}</h4>
                    <p>Videos Created</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="text-center p-4 bg-light rounded">
                    <i className="fas fa-star fa-3x text-primary mb-3"></i>
                    <h4>{stats.rating}</h4>
                    <p>User Rating</p>
                  </div>
                </div>
              </div>

              <div className="mt-5">
                <h3 className="text-primary mb-3">Why Choose {shortName}?</h3>
                <ul className="list-unstyled">
                  <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> High-quality live streaming</li>
                  <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> Easy-to-use interface</li>
                  <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> Community-driven platform</li>
                  <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> 24/7 customer support</li>
                  <li className="mb-2"><i className="fas fa-check text-primary me-2"></i> Secure and reliable service</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <BackToTop />
    </>
  );
};

export default AboutUs;
